<script lang="ts">
    import "./styles/tailwind.css";

    import type * as t from "./types";

    import { onMount } from "svelte";
    import { derived } from "svelte/store";
    import Segments from "./Segments.svelte";
    import { getSegmentConfig } from "./utils";
    import { trackEvents } from "./quiz-actions";
    import Footer from "./Footer.svelte";
    import ScrollableArea from "./components/ScrollableArea.svelte";
    import StepsSlider from "./components/StepsSlider.svelte";
    import { initCtx } from "./init-context";
    import type { QuizElement } from "./quiz";

    export let hostProps: t.QuizProps;
    export let host: QuizElement;

    export function start() {
        if ($state.status !== "initial") {
            return;
        }
        ctx.actions.startQuiz();
    }

    const ctx = initCtx(hostProps, host);
    const { state } = ctx;

    const isFooterVisible = derived(state, ($) => {
        const step = $.step.value;
        switch (step.type) {
            case "intro":
                return false;
            case "minigame":
            case "construct_minigame":
                return step.state?.gameStatus === "finished";
            case "segment_result":
                return (
                    step.state?.formStatus === "visible" &&
                    $.segment.next != null
                );
            default:
                const segmentConfig = getSegmentConfig($.config, $.segment);
                return segmentConfig != null;
        }
    });

    let innerWidth: number;

    onMount(() => {
        trackEvents(ctx);
    });
</script>

<svelte:window bind:innerWidth />

<div class="app flex size-full flex-col">
    <ScrollableArea class={"flex w-full flex-1 items-stretch"}>
        <StepsSlider stepIdx={$state.globalStepIdx}>
            <Segments segments={$state.segments} />
        </StepsSlider>
    </ScrollableArea>
    <Footer visible={$isFooterVisible} />
</div>

<style>
    .app {
        width: 100%;
        height: 100%;
        font-family: Montserrat, sans-serif;
    }
</style>
